<template lang="pug">
vm-prompt(
  @vm-cancel="close",
  @vm-accept="saveRecord",
  @vm-close="close",
  :vm-accept-text="$t('strings.accept')",
  :vm-cancel-text="$t('strings.cancel')",
  :vm-active="isModalSubmittalVisible",
  :vm-is-valid="!$v.submittal.$invalid",
  :vm-title="getTitle"
)
  vm-row(
    vm-align="center",
    vm-type="flex",
    vm-justify="space-between",
    vm-w="12"
  )
    vm-col(v-if="isAdd", vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(
          :placeholder="$t('submittals.package_name_placeholder')",
          :danger="$v.submittal.package_name.$invalid && $v.submittal.package_name.$model",
          :danger-text="$t('validation.required', { attribute: $t('submittals.package_name') })",
          v-model="submittal.package_name",
          :label="$t('submittals.package_name')"
        )
    vm-col(v-if="isAdd", vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-date-picker(
          style="width: 100%",
          :label="$t('submittals.starting_date')",
          :danger="$v.submittal.starting_date.$invalid && $v.submittal.starting_date.$model",
          :danger-text="$t('validation.required')",
          v-model="submittal.starting_date"
        )
    vm-col(v-if="!isAdd", vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-date-picker(
          v-if="!isAdd",
          style="width: 100%",
          :label="$t('submittals.end_date')",
          v-model="submittal.end_date"
        )
    vm-col(v-if="isAdd", vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-select(
          :label="$t('submittals.type')",
          v-model="submittal.type",
          :danger="$v.submittal.type.$invalid && $v.submittal.type.$model",
          :placeholder="$t('submittals.type_placeholder')"
        )
          vm-select-item(:value="1", text="JSS")
          vm-select-item(v-if="!customer", :value="2", text="Cano")
          vm-select-item(:value="3", text="Miscellaneous")
    vm-col(v-if="isAdd", vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        input(
          type="file",
          ref="file",
          v-on:change="handleFileUpload()",
          accept="application/pdf"
        )
    vm-col(v-if="isAdd", vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-textarea(
          :placeholder="$t('submittals.comments_placeholder')",
          v-model="submittal.comments",
          :label="$t('submittals.comments')"
        )
</template>
<script>
import { required, requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalSubmittal',
  props: {
    submittal: {
      type: Object
    },
    index: {
      type: Number
    },
    isAdd: {
      default: false,
      type: Boolean
    },
    customer: {
      default: false,
      type: Boolean
    }
  },
  validations () {
    return {
      submittal: {
        package_name: {
          required
        },
        starting_date: {
          required
        },
        end_date: {
          required: requiredIf(function () {
            return !this.isAdd
          })
        },
        type: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalSubmittalVisible', 'inOrder']),
    getTitle () {
      return this.isAdd ? this.$t('submittals.add') : this.$t('submittals.edit')
    }
  },
  methods: {
    ...mapActions([
      'setModalSubmittalVisible',
      'addSubmittal',
      'editSubmittal'
    ]),
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    async saveRecord () {
      if (this.isAdd) {
        await this.addSubmittal({
          submittal: this.submittal,
          project: this.inOrder,
          file: this.file
        })
      } else {
        await this.editSubmittal({
          submittal: this.submittal,
          project: this.inOrder
        })
      }
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalSubmittalVisible(false)
    }
  }
}
</script>
